import { useState, useEffect, ReactNode } from 'react'
import { ApprovalRequiredText } from '@components'
import { ErrorsTooltip } from '@datasets/components/errorsTooltip'
import { Role } from '@global/types'
import { useAppSelector } from '@redux/hooks'
import { Search } from './search'
import * as css from './styles'

interface Props {
  template: any
  submissionStatus?: ReactNode
  errors: any
  errorCount: number
  onErrorClick: () => void
  hideErrors?: boolean
  type?: any
  poweredBy?: any
  onSearchCallback?: (value: string) => void
  onKeyPress?: ((e: any) => void) | null
  onChange?: ((e: any) => void) | null
  children?: ReactNode[] | ReactNode
  detailsContent?: ReactNode
}

export const TableToolbar = ({
  onSearchCallback,
  template,
  submissionStatus = null,
  errors,
  errorCount,
  onErrorClick,
  hideErrors = false,
  children = null,
  onKeyPress = null,
  onChange = null,
  detailsContent = null,
}: Props) => {
  const [fieldsById, setFieldsById] = useState({})
  const user = useAppSelector((state: any) => state.Auth.user)
  const isApprovalRequired = Boolean(template?.settings?.require_approval)
  const isAdmin = user?.role === Role.OWNER

  useEffect(() => {
    setFieldsById(
      template?.dependencies?.columns?.reduce((memo, item) => {
        memo[item.field_id] = item
        return memo
      }, {}),
    )
  }, [template?.dependencies?.columns])

  return (
    <css.Toolbar>
      <Search onSearchCallback={onSearchCallback} onKeyPress={onKeyPress} onChange={onChange} />
      {isApprovalRequired && <ApprovalRequiredText isAdmin={isAdmin} />}
      <div style={{ marginRight: 'auto' }}>{submissionStatus}</div>
      {detailsContent}
      {!hideErrors && (
        <ErrorsTooltip
          errors={errors}
          errorCount={errorCount}
          onErrorClick={onErrorClick}
          fieldsById={fieldsById}
        />
      )}
      {children}
    </css.Toolbar>
  )
}
